import React from "react";
import PropTypes from "prop-types";

import Article from "../Main/Article";
import PostHeader from "./PostHeader";
import Content from "../Main/Content";
import PostFooter from "./PostFooter";

const Post = props => {
  const { post, author, slug, facebook } = props;
  const frontmatter = (post || {}).frontmatter;
  const title = ((post || {}).frontmatter || {}).title;
  const subTitle = ((post || {}).frontmatter || {}).subTitle;
  const date = ((post || {}).fields || {}).prefix;
  const html = (post || {}).html;
  const htmlAst = (post || {}).htmlAst;

  //console.log(htmlAst);

  //prettier-ignore
  return (
    <Article>
      <PostHeader title={title} subTitle={subTitle} date={date} />
      <Content html={html} />
      <div>
        <br/>
        <div id="mc_embed_signup">
          <p style={{textAlign: 'center', fontWeight: 'bold'}}>Sign up for my weekly newsletter.</p>
          <form action="https://juniorsintech.us19.list-manage.com/subscribe/post?u=f5510641e5a4605f8905521f9&amp;id=4a6af7fb09" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
              <div id="mc_embed_signup_scroll">
                  <input type="email" defaultValue="" name="EMAIL" className="email" id="mce-EMAIL" placeholder="email address" required />
              </div>
              <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                  <input type="text" name="b_f5510641e5a4605f8905521f9_4a6af7fb09" tabIndex="-1" defaultValue="" />
              </div>
              <div className="clear"><input style={{backgroundColor: '#1c1d1e', color: 'white'}} type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" /></div>
          </form>
        </div> 
      </div>
      <PostFooter author={author} post={post} slug={slug} facebook={facebook} />
    </Article>
  );
};

Post.propTypes = {
  post: PropTypes.object.isRequired,
  author: PropTypes.object.isRequired,
  slug: PropTypes.string.isRequired,
  facebook: PropTypes.object.isRequired
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/Post/Post.js